import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultKeyDetails,
  defaultEstimatesDialog,
  gasKeyDetailsAddons,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

export const originAffinityVariable: IPlanContent = {
  test: createPlanNameMatcher(['Origin Affinity Variable']),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
        electricity: defaultKeyDetails,
        gas: defaultKeyDetails,
        dual: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {},
    estimatesDialog: defaultEstimatesDialog({ customerType: 'residential' }),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-affinity-variable/',
      },
    },
  },
};
